<template>
  	<div ref="pageContainer">
    <!-- 导航栏 -->
    <header class="sticky top-0 z-50 bg-white bg-opacity-90 backdrop-blur shadow-sm py-4 h-24 md:px-24 md:height:0px" style="height:96px;">
      <div class="container mx-auto px-10 ">
        <div class="flex justify-between items-center">
          <div class="cursor-pointer">
            <img src="../assets/logo.png" width="164" height="60" @click="scrollToWithOffset('0')"/>
          </div>
          <nav class="hidden md:flex gap-8 text-sm text-gray-600">
            <a href="javascript:void(0);" class="nav-link hover:text-primaryBlue" @click="scrollToWithOffset('Banking')">Banking</a>
            <a href="javascript:void(0);" class="nav-link hover:text-primaryBlue" @click="scrollToWithOffset('Issuing')">Issuing</a>
			<a href="javascript:void(0);" class="nav-link hover:text-primaryBlue" @click="scrollToWithOffset('Exchange')">Exchange</a>
            <a href="javascript:void(0);" class="nav-link hover:text-primaryBlue" @click="scrollToWithOffset('Acquiring')">Acquiring</a>
            <a href="javascript:void(0);" class="nav-link hover:text-primaryBlue" @click="scrollToWithOffset('Company')">Company</a>
          </nav>
          <button class="bg-primaryBlue text-white px-5 py-2 rounded-full text-sm font-medium hover:bg-primaryBlueDark transition-colors" @click="scrollToWithOffset('4700')">
            Get Started
          </button>
        </div>
      </div>
    </header>

    <!-- 英雄区 -->
    <section class="py-16 text-center bg-cover bg-center" id="start" style="background-image: url('/bg1.png');" ref="Banking">
      <div class="container mx-auto md:px-24 ">
        <h1 class="text-5xl md:text-6xl font-bold text-gray-900 mb-4 leading-tight">
          <span class="text-brand-blue">Professional</span>, Intelligent Global<br>Fund Management Partner
        </h1>
        <p class="text-gray-600 max-w-5xl mx-auto mb-12 text-xl leading-relaxed">
          We combine advanced payment technology with deep compliance capabilities,<br> helping businesses seamlessly move funds, smartly handle exchanges, <br>and securely settle transactions across the globe.
        </p>

        <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-12">
          <!-- 左列卡片 -->
          <div class="space-y-4">
            <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
              <div class="flex items-center">
                <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primaryBlue shadow">
                  <span class="iconfont icon-faka text-xl"></span>
                </div>
                <h3 class="font-semibold text-gray-900 ml-5">Global Card Issuing</h3>
              </div>
              <p class="text-left text-gray-500 mt-3">Issue global cards instantly. Empower global teams. Control spending.</p>
            </div>
            <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow mt-4">
              <div class="flex items-center">
                <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primaryBlue shadow">
                  <span class="iconfont icon-xunizhanghuguanli text-xl"></span>
                </div>
                <h3 class="font-semibold text-gray-900 ml-5">Virtual Accounts</h3>
              </div>
              <p class="text-left text-gray-500 mt-3">Manage all accounts. Allocate funds clearly. Move money efficiently.</p>
            </div>
          </div>

          <!-- 中间图片 -->
          <div class="flex items-center justify-center mt-0 md:mt-12" >
            <img src="@/assets/unipay.png" width="500" height="200" class="hidden md:block">
			<img src="@/assets/center.png" width="500" height="200" class="block md:hidden">
          </div>
		  

          <!-- 右列卡片 -->
          <div class="space-y-4">
            <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
              <div class="flex items-center">
                <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primaryBlue shadow">
                  <span class="iconfont icon-waibi text-xl"></span>
                </div>
                <h3 class="font-semibold text-gray-900 ml-5">Currency Exchange</h3>
              </div>
              <p class="text-left text-gray-500 mt-3">Convert currencies in one place. Transparent. Simple.</p>
            </div>
            <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow mt-4">
              <div class="flex items-center">
                <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center text-primaryBlue shadow">
                  <span class="iconfont icon-rongzizulin text-xl"></span>
                </div>
                <h3 class="font-semibold text-gray-900 ml-5">Payment Acceptance</h3>
              </div>
              <p class="text-left text-gray-500 mt-3">Integrated card acceptance, digital wallets, bank transfers & smart routing.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 虚拟账户模块 -->
    <section id="banking" class="py-16 bg-cover bg-center" style="background-image: url('/bg2.png')" ref="Issuing">
      <div class="container mx-auto px-10 md:px-24">
        <div class="flex flex-col lg:flex-row gap-12 items-center">
          <div class="w-full lg:w-1/2">
            <h2 class="text-4xl font-bold text-gray-900 mb-4">
              <span class="text-brand-blue">Virtual Account </span>Setup
            </h2>
            <p class="text-gray-600 text-lg mb-8">We help you build a global fund network, making cross-border payments and capital allocation more efficient and seamless.</p>

            <div class="space-y-6">
              <div class="flex gap-4 items-start">
                <div class="w-28 h-28 bg-primaryBlueLight rounded-lg flex items-center justify-center text-primaryBlue flex-shrink-0">
                  <span class="iconfont icon-net-account text-5xl"></span>
                </div>
                <div>
                  <h3 class="text-xl font-semibold text-gray-900">Global Local Account Generation</h3>
                  <p class="text-gray-500 mt-2 text-base">Receive USD, EUR, HKD, GBP, SGD and more with full local details</p>
                </div>
              </div>
              <div class="flex gap-4 items-start">
                <div class="w-28 h-28 bg-greenLight rounded-lg flex items-center justify-center text-greenText flex-shrink-0">
                  <span class="iconfont icon-duozhanghu text-5xl"></span>
                </div>
                <div>
                  <h3 class="text-xl font-semibold text-gray-900">Multi-Account Management</h3>
                  <p class="text-gray-500 mt-2 text-base">Designed for complex structures, business separation and unified oversight</p>
                </div>
              </div>
              <div class="flex gap-4 items-start">
                <div class="w-28 h-28 bg-orangeLight rounded-lg flex items-center justify-center text-orangeText flex-shrink-0">
                  <span class="iconfont icon-zhinengzhuli text-5xl"></span>
                </div>
                <div>
                  <h3 class="text-xl font-semibold text-gray-900">Offshore VA & Onshore VA Support</h3>
                  <p class="text-gray-500 mt-2 text-base">Optimize cross-border payments, trade, fund distribution and tax planning</p>
                </div>
              </div>
              <div class="flex gap-4 items-start">
                <div class="w-28 h-28 bg-indigoLight rounded-lg flex items-center justify-center text-indigoText flex-shrink-0">
                  <span class="iconfont icon-keshihua text-5xl"></span>
                </div>
                <div>
                  <h3 class="text-xl font-semibold text-gray-900">Real-Time Visibility & Reporting</h3>
                  <p class="text-gray-500 mt-2 text-base">Track balances, reconcile transactions and auto-generate statements</p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-1/2">
            <img src="@/assets/account.png" class="w-full h-auto mt-16">
          </div>
        </div>
      </div>
    </section>

    <!-- 全球发卡 -->
    <div class="relative w-full h-[700px] overflow-hidden flex items-center justify-center" id="issuing" ref="Exchange">
      <div class="absolute top-12 left-1/2 transform -translate-x-1/2">
        <h2 class="text-4xl font-bold text-white">Global Card Issuing</h2>
      </div>
      <img src="@/assets/card.png" class="w-full h-full object-cover">
    </div>

    <!-- 跨境外汇 -->
    <section id="exchange" class="py-16 bg-cover bg-center" style="background-image: url('/bg3.png')" ref="Acquiring">
      <div class="container mx-auto px-10 text-center md:px-24">
        <h2 class="text-4xl font-bold text-gray-900 mb-4">Cross-Border & Foreign Exchange</h2>
        <p class="text-gray-600 text-lg max-w-3xl mx-auto mb-12">We provide transparent and efficient FX services, empowering<br> businesses to seize opportunities and reduce costs</p>

        <div class="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100">
            <div class="w-16 h-16 bg-brand-blue rounded-lg flex items-center justify-center text-white mx-auto">
              <span class="iconfont icon-fangyuanfenxibaogao text-4xl"></span>
            </div>
            <h3 class="font-semibold text-gray-900 mt-6 text-xl">Live Exchange Rate Charts</h3>
            <p class="text-gray-500 mt-4 text-left">Visualize trends to inform decisions</p>
          </div>
          <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100">
            <div class="w-16 h-16 bg-brand-blue rounded-lg flex items-center justify-center text-white mx-auto">
              <span class="iconfont icon-waibi text-4xl"></span>
            </div>
            <h3 class="font-semibold text-gray-900 mt-6 text-xl">Self-Service Currency Swap</h3>
            <p class="text-gray-500 mt-4 text-left">Swap currencies in-platform with one click</p>
          </div>
          <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100">
            <div class="w-16 h-16 bg-brand-blue rounded-lg flex items-center justify-center text-white mx-auto">
              <span class="iconfont icon-a-bianzu32 text-4xl"></span>
            </div>
            <h3 class="font-semibold text-gray-900 mt-6 text-xl">Full Transaction Tracking</h3>
            <p class="text-gray-500 mt-4 text-left">Record rate, amount, and status for every trade</p>
          </div>
          <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100">
            <div class="w-16 h-16 bg-brand-blue rounded-lg flex items-center justify-center text-white mx-auto">
              <span class="iconfont icon-qiandai text-4xl"></span>
            </div>
            <h3 class="font-semibold text-gray-900 mt-6 text-xl">Cross-Border CNH Support</h3>
            <p class="text-gray-500 mt-4 text-left">Collect, pay, and settle in CNY with local payment connectivity</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 收单结算 -->
    <section id="acquiring" class="py-1 bg-cover bg-center" style="background-image: url('/bg4.png')" ref="Company">
      <div class="container mx-auto px-10 md:px-24">
        <div class="flex flex-col lg:flex-row gap-12 items-center">
          <div class="w-full lg:w-1/2">
            <h2 class="text-5xl font-bold text-gray-900 mb-4 leading-28">
              <span class="text-brand-blue text-left">Acquiring</span> & Settlement Routing
            </h2>
            <p class="text-gray-600 text-2xl">Access and integrate the world's leading payment options</p>
          </div>
          <div class="w-full lg:w-1/2">
            <div class="bg-gray-50 p-6 rounded-xl">
              <img src="@/assets/sk.png" class="w-full rounded-lg mb-4">
              <ul class="space-y-3 text-gray-600">
                <li class="flex items-center gap-3 text-left">
                  <span class="w-6 h-6 rounded-full bg-primaryBlueLight inline-block"></span>
                  <span>International Card Acquiring: VISA, Mastercard & more</span>
                </li>
                <li class="flex items-center gap-3 text-left">
                  <span class="w-6 h-6 rounded-full bg-primaryBlueLight inline-block"></span>
                  <span>Digital Wallets</span>
                </li>
                <li class="flex items-center gap-3 text-left">
                  <span class="w-6 h-6 rounded-full bg-primaryBlueLight inline-block"></span>
                  <span>Local Bank Transfers: ACH, SEPA, FPS & other networks</span>
                </li>
                <li class="flex items-center gap-3 text-left">
                  <span class="w-6 h-6 rounded-full bg-primaryBlueLight inline-block"></span>
                  <span>Custom Settlement Routing: Funds settled to your designated bank or virtual accounts</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
	
	<!-- ======================优势模块======================= -->
	<section class="py-10 text-center bg-cover bg-center " id="start" style="background-image: url('/bg5.jpg')">
	  <div class="container mx-auto px-10 md:px-24">
	    <h1 class="text-3xl md:text-3xl font-bold text-gray-900 mb-4 leading-tight">
	      <span class="text-brand-black">Our Strengths</span>
	    </h1>
	
	   <div class="grid grid-cols-1 lg:grid-cols-12 gap-6 mb-12">
	     <!-- 左列 3份 -->
	     <div class="lg:col-span-8 space-y-4 mt-8">
		<div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
	       <div class="flex items-center gap-4">
			 <!-- 左侧图标 -->
			 <div class="w-10 h-10 rounded-lg flex items-center justify-center text-primaryBlue shadow flex-shrink-0" style="background:#2E8BFE">
			   <span class="iconfont icon-quanqiuheguikuangchang text-3xl text-white"></span>
			 </div>
			 <!-- 右侧文字：标题 + 描述 上下 -->
			 <div class="flex-1 text-left">
			   <h3 class="font-semibold text-gray-900">Global Compliance</h3>
			   <p class="text-gray-500 mt-1">Licensed under Swiss SRO with fully regulated fund handling.</p>
			 </div>
	       </div>
		   </div>
	       <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
	         <div class="flex items-center gap-4">
				 <!-- 左侧图标 -->
				 <div class="w-10 h-10 rounded-lg flex items-center justify-center text-primaryBlue shadow flex-shrink-0" style="background:#2E8BFE">
				   <span class="iconfont icon-duoqudaojicheng text-3xl text-white"></span>
				 </div>
				 <!-- 右侧文字：标题 + 描述 上下 -->
				 <div class="flex-1 text-left">
				   <h3 class="font-semibold text-gray-900">Fast & Flexible Integration</h3>
				   <p class="text-gray-500 mt-1">Quick API/SDK integration compatible with your systems.</p>
				 </div>
	         </div>
	       </div>
	       <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
	         <div class="flex items-center gap-4">
	         <div class="w-10 h-10 rounded-lg flex items-center justify-center text-primaryBlue shadow flex-shrink-0" style="background:#2E8BFE">
	           <span class="iconfont icon-duobizhongmulti-currency text-3xl text-white"></span>
	         </div>
	         <!-- 右侧文字：标题 + 描述 上下 -->
	         <div class="flex-1 text-left">
	           <h3 class="font-semibold text-gray-900">Multi-Currency Coverage</h3>
	           <p class="text-gray-500 mt-1">Supports USD, EUR, SGD, and other major currencies.</p>
	         </div>
	       </div>
		   </div>
	       <div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
	         <div class="flex items-center gap-4">
				 <!-- 左侧图标 -->
				 <div class="w-10 h-10 rounded-lg flex items-center justify-center text-primaryBlue shadow flex-shrink-0" style="background:#2E8BFE">
				   <span class="iconfont icon-zhuanjiatuandui text-3xl text-white"></span>
				 </div>
				 <!-- 右侧文字：标题 + 描述 上下 -->
				 <div class="flex-1 text-left">
				   <h3 class="font-semibold text-gray-900">Expert Team</h3>
				   <p class="text-gray-500 mt-1">Core members from UnionPay, card networks, and top payment platforms.</p>
				 </div>
	         </div>
	       </div>
			<div class="bg-white bg-opacity-60 p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
			  <!-- 改成左右布局：flex 横向排列 -->
			  <div class="flex items-center gap-4">
				<!-- 左侧图标 -->
				<div class="w-10 h-10 rounded-lg flex items-center justify-center text-primaryBlue shadow flex-shrink-0" style="background:#2E8BFE">
				  <span class="iconfont icon-anquanjingyanku text-3xl text-white"></span>
				</div>
				<!-- 右侧文字：标题 + 描述 上下 -->
				<div class="flex-1 text-left">
				  <h3 class="font-semibold text-gray-900">Proven Experience</h3>
				  <p class="text-gray-500 mt-1">Trusted by Fortune 500 companies and global brands.</p>
				</div>
			  </div>
			</div>
	     </div>
	   
	     <!-- 右列 7份 -->
	     <div class="lg:col-span-4  mt-4">
	        <img src="@/assets/ht.png" class="w-full h-full object-cover">
	     </div>
	   </div>
	  </div>
	</section>
	
	
    <!-- 合作号召模块 -->
	<section class="relative">
		<section class="py-8 absolute items-center bg-cover bg-center cta-section hidden md:block px-24" 
		style="background-image: url('/bg6.png');width:100%;border-radius: 30px;mx-auto;top:-80px;">
		  <div class="text-center max-w-7xl mx-auto px-4">
			<div class="flex items-center justify-between">
			  <div class="text-lg font-bold text-black w-[80%] ml-8 cta-title">Partner with a global payment expert-deep in business,<br> tech, and compliance.</div>
			  <button style="background: #2E8BFE" class="bg-blue-X hover:bg-blue-700 text-white px-6 py-3 rounded-full font-medium mt-4 contact-btn" @click="scrollToWithOffset('4700')">Get in Touch</button>
			</div>
		  </div>
		</section>
	</section>
	
	 <!-- 页脚 全部居中 -->
	   <footer class="text-white pt-16" style="background:#003372;height:635px md:height:0px">
	     <div class="max-w-[1280px] mx-auto px-10 grid grid-cols-1 md:grid-cols-2 gap-8 md:px-24">
	       <!-- 左侧区域 -->
	       <div class="flex flex-col gap-6">
	         <!-- Logo -->
	         <div class="mb-6">
	           <img src="../assets/logo-withe.png" alt="UNIPAY Logo" class="h-[50px] w-auto">
	         </div>
	 
	         <!-- 导航 + 联系信息 行 -->
	         <div class="flex flex-wrap gap-8 md:gap-[80px]">
	           <!-- 第一列 -->
	           <div class="flex flex-col gap-5 text-left">
	             <router-link to="/" class="text-white text-base hover:text-gray-300">Home</router-link>
	             <router-link to="/banking" class="text-white text-base hover:text-gray-300">Banking</router-link>
	             <router-link to="/exchange" class="text-white text-base hover:text-gray-300">Exchange</router-link>
	             <router-link to="/acquiring" class="text-white text-base hover:text-gray-300">Acquiring</router-link>
	           </div>
	 
	           <!-- 第二列 -->
	           <div class="flex flex-col gap-5 text-left">
	             <router-link to="/issuing" class="text-white text-base hover:text-gray-300">Issuing</router-link>
	             <router-link to="/company" class="text-white text-base hover:text-gray-300">Company</router-link>
	           </div>
	 
	           <!-- 联系信息 -->
	           <div class="flex flex-col gap-5 text-left">
	             <div class="flex items-start gap-2">
	               <span class="text-lg">✉️</span>
	               <div>
	                 <div class="text-white text-base">Email:</div>
	                 <div class="text-white text-base">operation@unipay-global.com</div>
	               </div>
	             </div>
	             <div class="flex items-start gap-2">
	               <span class="text-lg">📍</span>
	               <div>
	                 <div class="text-white text-base">Address:</div>
	                 <div class="text-white text-base">Bleichistrasse 8, 6300 Zug,</div>
	                 <div class="text-white text-base">Switzerland.</div>
	               </div>
	             </div>
	           </div>
	         </div>
	 
	         <!-- 标语 -->
	         <div class="border-t border-white/20 pt-5 mt-2 text-lg text-left">
	           <p class="py-1">Professional, Intelligent Global Fund Management Partner</p>
	           <p class="py-1">Ready to streamline your global operations?</p>
	         </div>
	 
	         <!-- 底部链接 -->
	         <div class="pt-4 flex gap-6">
	           <router-link to="/policy" class="text-white text-sm hover:underline">Privacy Policy</router-link>
	           <router-link to="/terms" class="text-white text-sm hover:underline">Terms & Conditions</router-link>
	         </div>
	       </div>
	 
	       <!-- 右侧表单区域 -->
	       <div class="flex flex-col gap-6">
	         <h2 class="text-xl font-bold">Contact Us</h2>
	         <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
	           <div class="form-group">
	             <label class="block text-sm mb-2">First name *</label>
	             <input type="text" v-model="firstName" required
	               class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	           </div>
	           <div class="form-group">
	             <label class="block text-sm mb-2">Last name *</label>
	             <input type="text" v-model="lastName" required
	               class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	           </div>
	           <div class="form-group">
	             <label class="block text-sm mb-2">Email *</label>
	             <input type="email" v-model="email" required
	               class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	           </div>
	           <div class="form-group">
	             <label class="block text-sm mb-2">Phone *</label>
	             <input type="tel" v-model="phone"
	               class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70">
	           </div>
	           <div class="md:col-span-2">
	             <label class="block text-sm mb-2">Message *</label>
	             <textarea v-model="message" required rows="4"
	               class="w-full p-3 bg-transparent border border-white rounded-none text-white placeholder-white/70"></textarea>
	           </div>
	           <button id="submit-btn" @click="sendMsg"
	             class="md:col-span-2 bg-blue-600 hover:bg-blue-700 text-white py-3 font-medium transition-colors">
	             Submit
	           </button>
	         </div>
	       </div>
	     </div>
	 
	     <!-- 版权信息 -->
	     <div class="max-w-[1280px] mx-auto px-4 text-center py-6 mt-8 text-white text-sm border-t border-white/10">
	       <p>Copyright © 2025 UNIPAY GLOBAL. All rights reserved.</p>
	     </div>
	   </footer>
	 
	   <div class="flex justify-center">
	     <IpAlert :visible="showAlert" :content="alertContent" @close="showAlert = false" />
	   </div>
	
    <!-- 优势模块 / cta / 页脚 全部已兼容，原有JS不动 -->
  </div>
</template>

<style>
/* 原有自定义兜底保留，不冲突Tailwind2 */
* {margin:0;padding:0;box-sizing:border-box;font-family:Microsoft YaHei;}
</style>

<script>
import axios from 'axios';
import IpAlert from "./IpAlert.vue";

export default {
  components: {
    IpAlert
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      phone: '',
      email: '',
      message: '',
      showAlert: false,
      alertContent: ''
    };
  },
  watch: {
    $route(to) {
	  console.info(to.path+"=======================")
      if (to.path === '/banking') {
        this.$nextTick(() => {
          this.scrollToWithOffset('Banking');
        });
      }else  if (to.path === '/exchange') {
        this.$nextTick(() => {
          this.scrollToWithOffset('Exchange');
        });
      }else  if (to.path === '/acquiring') {
        this.$nextTick(() => {
          this.scrollToWithOffset('Acquiring');
        });
      }else  if (to.path === '/issuing') {
        this.$nextTick(() => {
          this.scrollToWithOffset('Issuing');
        });
      }else  if (to.path === '/company') {
        this.$nextTick(() => {
          this.scrollToWithOffset('Company');
        });
      }else{
		 this.$nextTick(() => {
		   this.scrollToWithOffset('0');
		 }); 
	  }
    }
  },
  methods: {
    // 修复版：正确滚动（不会报错、不会错位）
    scrollToWithOffset(refName) {
      const offset = 96; // 导航栏高度，避免被挡住
      let targetTop = 0;

      // 根据 ref 名字获取 DOM
      const el = this.$refs[refName];
	  console.info(el);
      
      if (el) {
        // 获取元素到顶部距离
        targetTop = el.clientHeight;
		if('Issuing' == refName){
			targetTop =targetTop+this.$refs['Issuing'].clientHeight;
		}
		if('Exchange' == refName){
			targetTop =targetTop+this.$refs['Issuing'].clientHeight+this.$refs['Banking'].clientHeight;
		}
		if('Acquiring' == refName){
			targetTop =targetTop+this.$refs['Issuing'].clientHeight+this.$refs['Banking'].clientHeight+this.$refs['Exchange'].clientHeight;
		}
		if('Company' == refName){
			targetTop =targetTop+this.$refs['Acquiring'].clientHeight+this.$refs['Issuing'].clientHeight+this.$refs['Banking'].clientHeight+this.$refs['Exchange'].clientHeight;
		}
      } else {
        // 直接跳数字（Get Started 按钮）
        targetTop = Number(refName) - offset;
      }

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    },

    // 修复版：表单验证（全部正常生效）
    sendMsg() {
      if (this.firstName.trim() === '') {
        this.showAlert = true;
        this.alertContent = "First name is required";
        return;
      }
      if (this.lastName.trim() === '') {
        this.showAlert = true;
        this.alertContent = "Last name is required";
        return;
      }
      if (!this.checkEmail(this.email)) {
        this.showAlert = true;
        this.alertContent = "Please enter a valid email";
        return;
      }
      if (this.phone.trim() === '') {
        this.showAlert = true;
        this.alertContent = "Phone is required";
        return;
      }
      if (this.message.trim() === '') {
        this.showAlert = true;
        this.alertContent = "Message is required";
        return;
      }

      // 提交
      axios.post('/api/email', {
        firstName: this.firstName,
        lastName: this.lastName,
        phone: this.phone,
        email: this.email,
        message: this.message
      }).then(res => {
        if (res.data.code === '000') {
          document.getElementById('submit-btn').disabled = true;
          this.showAlert = true;
          this.alertContent = "Submitted successfully!";
        }
      }).catch(err => {
        console.log(err)
      })
    },

    // 邮箱验证
    checkEmail(email) {
      if (!email || typeof email !== 'string') return false;
      const reg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      return reg.test(email.trim());
    }
  }
};
</script>
